// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__vpsFI","accordion__title":"Accordion_accordion__title__tBRYt","accordion__item":"Accordion_accordion__item__GjOe1"};